import { requestWithToken } from '../utilities/request';
const path = '/api/private/user_profiles';

/**
 * api :GET, '/api/private/user_profiles', 'プロファイル画面ユーザー情報を取得します'
 * @param id {int}
 * @param param {object}
 */
const index = () => {
  console.log('debug', 'UserProfiles.js index');
  return requestWithToken({
    method: 'GET',
    url: path,
  });
};

/**
 * ユーザー情報取得
 * @param id {int}
 * @param param {object}
 */
const show = (id, param) => {
  // console.log('debug', `UserProfiles.js UserProfileService.show ${id}`);

  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${id}`),
    params: param,
  });
};

const update = id => {
  return requestWithToken(
    {
      method: 'PATCH',
      url: '/api/private/users/agreed_terms',
      params: { id },
    },
    false
  );
};

export const UserProfileService = {
  index,
  show,
  update,
};
export default UserProfileService;



// WEBPACK FOOTER //
// ./src/services/UserProfiles.js